import { Container, Stack, Typography } from "@mui/material";
import ShippingAddressForm from "./components/ShippingAddressForm";
import ShippingDisclaimer from "./components/ShippingDisclaimer";
import { useQuestions } from "src/context/QuestionsProvider";
import { useProduct } from "src/context/ProductProvider";

const ShippingAddress = () => {
  const page = "shipping-information";
  const title = useQuestions((q) => q.title);
  const productSlug = useProduct((product) => product.slug);

  return (
    <Container maxWidth="sm">
      <Stack gap={2}>
        {productSlug === "iwl-ot" ? null : <ShippingDisclaimer page={page} />}
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
        <ShippingAddressForm />
      </Stack>
    </Container>
  );
};

export default ShippingAddress;
